import { useRef, useState } from 'react';
import { nameDocument } from '../../../Utility/nameDocument';
import { replaceTradeMark } from '../../../Utility/replaceTradeMark';
// import ProductImageModal from './ProductImageModal';
// import { ShareProduct } from './ProductShare';
import Loading from '../../../Components/Loading';
import logo from '../../../assets/Hirschnow.png';
import { OrderProduct } from '../../../Types/OrderDetail';
import { BidProduct } from '../../../Types/Bid';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../../../firebase';
import { useLocation } from 'react-router-dom';
import { Card, CardBody, CardHeader, Container } from 'reactstrap';
import { IosShare } from '@mui/icons-material';
import ImageCarousel from './ProductImageCarousel';

const ProductDetail = () => {
    const location = useLocation();
    const item = location.state?.item as OrderProduct | BidProduct;
    const carouselRef = useRef(null);
    const viewShotRef = useRef(null);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const data = item?.details?.[0]?.IMAGES?.length
        ? item.details[0].IMAGES
        : [{ PHOTO: null, isPlaceholder: true }];
    const [modalVisible, setModalVisible] = useState(false);

    const handleModal = (index: number) => {
        setSelectedIndex(index)
        setModalVisible(true)
    }

    const handleShare = async ({ item }: { item: OrderProduct | BidProduct }) => {
        logEvent(analytics, 'product_share', {
            name: 'product share',
            description: 'User shared a product'
        })

        // if (!viewShotRef.current?.capture) return;

        // const uri = await viewShotRef.current.capture();
        // ShareProduct({ item, uri });
    };

    const handleOpenDocument = async (document: string) => {
        logEvent(analytics, 'product_document', {
            name: 'product document',
            description: 'User opened product document'
        })
    }

    if (!item || item === null || Object.keys(item).length === 0) {
        return (
            <div>
                <Loading />
            </div>
        )
    };

    return (
        <>
            <Container>
                <div>
                    <Card className='mb-3'>
                        <CardBody>
                            <span className='itemName d-block text-start fw-bold'>{item.details[0].MANUFACTURER_NAME}</span>
                            <span className='itemDescription d-block text-start'>{replaceTradeMark(item.details[0].PRODUCTNAME)}</span>
                            <ImageCarousel items={data} />
                            <div>
                                <div 
                                    style={{ position: 'absolute', bottom: 10, right: 50, cursor: 'pointer' }}
                                    onClick={() => handleShare({ item })}
                                >
                                    <IosShare />
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                    {item.details[0].ATTRIBUTES && 
                        <Card className='mb-3'>
                            <CardHeader>
                                <span className='headerText'>Specifications</span>
                            </CardHeader>
                            <CardBody style={{ textAlign: 'start' }}>
                                {item.details[0].ATTRIBUTES.map((item, index) => (
                                    <div 
                                        style={{
                                            flexDirection: 'row', 
                                            justifyContent: 'space-between', 
                                            paddingBlock: 5,
                                            display: 'flex',
                                        }}
                                        key={index}
                                    >
                                        <div style={{ flex: 1 }}>
                                            <span>{`${item.ATTRIBUTE}:`}</span>
                                        </div>
                                        <div style={{ flex: 1 }}>
                                            <span>{`${replaceTradeMark(item.VALUE)} `}{item.UOM && item.UOM}</span>
                                        </div>
                                    </div>    
                                ))}
                            </CardBody>
                        </Card>
                    }
                    {item.details[0].ITEM_FEATURES && (
                        <Card className='mb-3'>
                            <CardHeader>
                                <span className='headerText'>Features</span>
                            </CardHeader>
                            <CardBody style={{ textAlign: 'start' }}>
                                {item.details[0].ITEM_FEATURES.match(/<li>(.*?)<\/li>/g)?.map((item) => (
                                    <div style={{ flexDirection: 'row', alignItems: 'baseline',}}>
                                        <span style={{ fontSize: 16, fontWeight: 'bold' }}>{`\u2022 `}</span>
                                        <span>{replaceTradeMark(item.replace(/<\/?li>/g, '')) || []}</span>
                                    </div>
                                ))}
                            </CardBody>
                        </Card>
                    )}
                    {item.details[0].DOCUMENTS && 
                        <Card className='mb-3'>
                            <CardHeader>
                                <span className='headerText'>Documents</span>
                            </CardHeader>
                            <CardBody>
                                {item.details[0].DOCUMENTS.map((item, index) => (
                                    <div style={{ justifyContent: 'center', alignItems: 'center' }}>
                                        <a
                                            key={index}
                                            style={{ paddingBlock: 10, }}
                                            onClick={() => handleOpenDocument(item.DOCUMENT)}
                                            href={item.DOCUMENT}
                                            target='_blank'
                                        >
                                                <span 
                                                    style={{ 
                                                        justifyContent: 'center',
                                                        textDecorationLine: 'underline', 
                                                        color: '#0000FF',
                                                    }}
                                                
                                                >{nameDocument(item.DOCUMENT, index)}</span>
                                        </a>
                                    </div>
                                ))}
                            </CardBody>
                        </Card>
                    }
                </div>
            </Container>
                
                {/* <ProductImageModal 
                    visible={modalVisible} 
                    onClose={() => setModalVisible(false)}
                    data={data}
                    initialIndex={selectedIndex}
                /> */}
        </>
    )
};

export default ProductDetail;